import React from 'react';
import ClickOutsideHandler from '../../common/ClickOutsideHandler';
import { map } from 'lodash';

const icons = {
    imprints: require('!svg-inline-loader!../../../../public/img/labels.svg'),
    artists: require('!svg-inline-loader!../../../../public/img/artists.svg'),
    products: require('!svg-inline-loader!../../../../public/img/products.svg'),
    projects: require('!svg-inline-loader!../../../../public/img/projects.svg'),
    tracks: require('!svg-inline-loader!../../../../public/img/tracks.svg')
}

function getFilterItem(filter, key) {
    const excludeKey = `exclude_${key}`;
    const exclude = Array.isArray(filter[excludeKey]) && filter[excludeKey].length > 0 ? ` - ${filter[excludeKey].length}` : '';
    return <li key={key} className="accordeon-filter-search-item"><span className="accordeon-filter-search-icon" dangerouslySetInnerHTML={{__html: icons[key]}} /> {filter[key]? filter[key].length : 0} {exclude}</li>;
}

export default function Accordion(props) {
    const opened = props.accordion && props.accordion[props.id],
        { readonly = false, show = true } = props, 
        filter = props.filter && props.filter[props.id];
    let itemsCount = null;
    if(filter && Array.isArray(filter) && props.id != 'imprints' && props.id != 'transactionTypes' && props.id != 'sources')
        itemsCount = filter.length || 'All'; 

    const prevDateRange = props.prevDateRangeEnable && props.prevDateStart && props.prevDateEnd ? <React.Fragment>
        <div className="previous-date-range-label">
            <span className="font-normal filter-label">Previous Date Range</span>
            <div className="filter-date-range-values">
                {props.prevDateStart} to {props.prevDateEnd}
            </div>
        </div>
    </React.Fragment> : null

    return show ? <div className={`form-group ${props.className} ${props.id} ${opened ? 'opened' : ''}`}>  
        <ClickOutsideHandler onClickOutside={(e) => { if(!readonly) {props.closeAccordion(props.id)} }}>
            <div className={"filter-label-container"} onClick={(e)=>{ if(!readonly) {props.toggleAccordion(props.id)} }}>
                <label className="font-normal filter-label" >
                    <div className="filter-label-inner">
                        {props.label}{(itemsCount ? ` (${itemsCount})` : '')} {props.vendorsCount && `(${props.vendorsCount})`}
                        {!readonly && <span className={`caret ${opened && 'opened'}`}></span>}
                    
                    <div className="filter-date-range-values">
                        { props.dateStart && props.dateEnd && (`${props.dateStart} to ${props.dateEnd}`) }
                        { props.genresList && props.genresList }
                        { props.source && props.source }
                        { props.selectedReleaseDateLabel && props.selectedReleaseDateLabel }
                        { props.periodValue && props.periodValue }
                        { Array.isArray(props.multiValue) && <span>{ props.multiValue.length ? map(props.multiValue, 'label').join(', ') : 'All'}</span>  }
                        { props.id == 'imprints' && <ul className="accordeon-filter-search-results">
                            {Object.keys(icons).map(key=>getFilterItem(props.filter, key))}
                        </ul>}
                    </div>
                    </div>
                    { prevDateRange }
                </label>
            </div>

            {opened && 
                <div className={`form-group-inner ${props.id}`}>
                    {props.children}
                </div>
            }
        </ClickOutsideHandler>
    </div> : null;
    
}
